import React from 'react';
import { expandFontTheme, theme, useLocalizationContext } from '@contrast-security-inc/design-system-foundations';
import { escapeString } from '../shared';
import { css } from '@emotion/css';
export const highlightedTextStyles = css `
  ${expandFontTheme(theme.font.bodyStrong)};
`;
export const HighlightedText = ({ itemValue, inputText, testId }) => {
    const { locale } = useLocalizationContext();
    const collator = new Intl.Collator(locale, { sensitivity: 'base' });
    const itemValueSplits = itemValue.split(new RegExp(`(${escapeString(inputText)})`, 'i'));
    return (React.createElement(React.Fragment, null, itemValueSplits.map((itemValueSplit, index) => (React.createElement("span", { key: `${itemValueSplit}-${index}`, className: collator.compare(itemValueSplit, inputText) === 0 ? highlightedTextStyles : '', "data-testid": testId && `${testId}-highlighted-text-${itemValueSplit}` }, itemValueSplit)))));
};
